__turbopack_context__.v({
  "contentStack": "MarketplaceV3-module-scss-module__AjTo4G__contentStack",
  "hpv2Blink": "MarketplaceV3-module-scss-module__AjTo4G__hpv2Blink",
  "hpv2DemoBounce": "MarketplaceV3-module-scss-module__AjTo4G__hpv2DemoBounce",
  "hpv2DemoFadeIn": "MarketplaceV3-module-scss-module__AjTo4G__hpv2DemoFadeIn",
  "hpv2DemoProgress": "MarketplaceV3-module-scss-module__AjTo4G__hpv2DemoProgress",
  "hpv2DemoScaleIn": "MarketplaceV3-module-scss-module__AjTo4G__hpv2DemoScaleIn",
  "hpv2DemoSlideIn": "MarketplaceV3-module-scss-module__AjTo4G__hpv2DemoSlideIn",
  "hpv2FadeLeft": "MarketplaceV3-module-scss-module__AjTo4G__hpv2FadeLeft",
  "hpv2FadeRight": "MarketplaceV3-module-scss-module__AjTo4G__hpv2FadeRight",
  "hpv2FadeUp": "MarketplaceV3-module-scss-module__AjTo4G__hpv2FadeUp",
  "hpv2FloatA": "MarketplaceV3-module-scss-module__AjTo4G__hpv2FloatA",
  "hpv2FloatB": "MarketplaceV3-module-scss-module__AjTo4G__hpv2FloatB",
  "hpv2HeroFadeIn": "MarketplaceV3-module-scss-module__AjTo4G__hpv2HeroFadeIn",
  "hpv2HeroFadeInOpacity": "MarketplaceV3-module-scss-module__AjTo4G__hpv2HeroFadeInOpacity",
  "hpv2HeroSlideIn": "MarketplaceV3-module-scss-module__AjTo4G__hpv2HeroSlideIn",
  "hpv2PriceShimmer": "MarketplaceV3-module-scss-module__AjTo4G__hpv2PriceShimmer",
  "hpv2PulseDot": "MarketplaceV3-module-scss-module__AjTo4G__hpv2PulseDot",
  "hpv2ScaleUp": "MarketplaceV3-module-scss-module__AjTo4G__hpv2ScaleUp",
  "main": "MarketplaceV3-module-scss-module__AjTo4G__main",
});
